<mat-card appearance="outlined" class="profile-card" *ngIf="wasteProfile">
  <mat-card-title class="title">
    <span class="left-content">
      Modified {{ wasteProfile.lastModifiedDate | date: dateFormat }}
    </span>
    <span class="right-content" *ngIf="showExpiryDate">
      Exp. {{ wasteProfile.expiryDate | date: dateFormat }}
    </span>
    <!-- <span class="right-content" *ngIf="showExpectedApprovalDate">
      Decision By {{ wasteProfile.expectedResponseDate | date: dateFormat }}
    </span> -->
    <span class="right-content" *ngIf="showReviewed">
      Reviewed by Republic
    </span>
  </mat-card-title>
  <mat-card-content>
    <div class="card-details">
      <div class="profile">
        <span class="profile-title">{{ wasteProfile.name }}</span>
        <span class="profile-details">{{ wasteProfile.generator?.name }}</span>
        <span class="profile-address">{{
          wasteProfile.generator?.siteAddress | address
        }}</span>
        <span class="profile-title"
          >{{ wasteProfile.type | enum: labels }} Profile</span
        >
        <span
          class="profile-title"
          *ngIf="wasteProfile.isChange && !wasteProfile.isRecertification"
          >Change Request</span
        >
        <span
          class="profile-title"
          *ngIf="wasteProfile.isRecertification && !wasteProfile.isChange"
          >Recertification</span
        >
        <span
          class="profile-title"
          *ngIf="!wasteProfile.isRecertification && !wasteProfile.isChange"
          >New Profile</span
        >
        <span
          class="profile-title"
          *ngIf="wasteProfile.isRecertification && wasteProfile.isChange"
          >Recert with Change</span
        >
        <span
          class="analytical-report-needed"
          *ngIf="showAnalyticalRequiredOnNextRecert"
        >
          Analytical Report Required
        </span>
        <span class="profile-id">{{ wasteProfile.id }}</span>
        <!-- TODO: tonte refactor need to re-map this to correct attriubute //-->
      </div>
      <div class="status" fxLayout="column" fxLayoutAlign="start end">
        <digital-platform-status-chip
          [status]="customerStatus"
          [label]="statusLabel"
        >
        </digital-platform-status-chip>
        <span class="status-id">{{ wasteProfile.number }}</span>
        <span class="status-landfill" *ngIf="showLandfill">{{
          wasteProfile.destination?.name
        }}</span>
        <span class="state-waste-code" *ngIf="showStateWasteCode">{{
          wasteProfile.stateApprovalWasteCode
        }}</span>
      </div>
    </div>

    <div class="card-actions">
      <ng-container *digitalPlatformPermission="'update:waste_profile'">
        <div class="card-button" *ngIf="showMakeRevisions">
          <a
            mat-button
            color="accent"
            class="action-required"
            *ngIf="!editChange && !editRecertification"
            [routerLink]="'/waste-profiles/edit/' + wasteProfile.id"
            matTooltip="Updates Required"
          >
            <mat-icon svgIcon="edit"></mat-icon>
            Updates Required
          </a>
          <a
            mat-button
            color="accent"
            class="action-required"
            *ngIf="editChange"
            [routerLink]="'/waste-profiles/change/' + wasteProfile.id"
            [queryParams]="{ continue: true }"
            matTooltip="Updates Required"
          >
            <mat-icon svgIcon="edit"></mat-icon>
            Updates Required
          </a>
          <a
            mat-button
            color="accent"
            class="action-required"
            *ngIf="editRecertification"
            [routerLink]="'/waste-profiles/recertify/' + wasteProfile.id"
            [queryParams]="{ continue: true }"
            matTooltip="Updates Required"
          >
            <mat-icon svgIcon="edit"></mat-icon>
            Updates Required
          </a>
        </div>
      </ng-container>

      <ng-container *digitalPlatformPermission="'update:waste_profile'">
        <div class="card-button" *ngIf="showEdit">
          <a
            mat-button
            color="accent"
            class="not-submitted"
            *ngIf="!editChange && !editRecertification"
            [routerLink]="'/waste-profiles/edit/' + wasteProfile.id"
            matTooltip="Edit"
          >
            <mat-icon svgIcon="edit"></mat-icon>
            Edit
          </a>
          <a
            mat-button
            color="accent"
            class="not-submitted"
            *ngIf="editChange"
            [routerLink]="'/waste-profiles/change/' + wasteProfile.id"
            [queryParams]="{ continue: true }"
            matTooltip="Edit"
          >
            <mat-icon svgIcon="edit"></mat-icon>
            Edit
          </a>
          <a
            mat-button
            color="accent"
            class="not-submitted"
            *ngIf="editRecertification"
            [routerLink]="'/waste-profiles/recertify/' + wasteProfile.id"
            [queryParams]="{ continue: true }"
            matTooltip="Edit"
          >
            <mat-icon svgIcon="edit"></mat-icon>
            Edit
          </a>
        </div>
      </ng-container>

      <ng-container *digitalPlatformPermission="'delete:waste_profile'">
        <div class="card-button" *ngIf="showDelete">
          <a
            mat-button
            (click)="openDialog(deleteDialog)"
            color="accent"
            matTooltip="Delete"
          >
            <mat-icon>delete_outline</mat-icon>
            {{ isFullyExpired() ? '' : 'Delete' }}
          </a>
        </div>
      </ng-container>

      <ng-container *digitalPlatformPermission="'recertify:waste_profile'">
        <div
          class="card-button"
          matTooltip="{{ recertifyTooltipText() }}"
          *ngIf="showRecertify"
        >
          <a
            mat-button
            color="accent"
            class="action-required"
            [ngClass]="isFullyExpired() ? 'disabled' : ''"
            routerLink="/waste-profiles/recertify/{{ wasteProfile.id }}"
            matTooltip="Recertify"
          >
            <mat-icon
              svgIcon="renew"
              [ngClass]="isFullyExpired() ? 'translucent' : ''"
            ></mat-icon>
            {{ isFullyExpired() ? '' : 'Recertify' }}
          </a>
        </div>
      </ng-container>

      <ng-container *digitalPlatformPermission="'change:waste_profile'">
        <div class="card-button" *ngIf="showChange">
          <a
            mat-button
            color="accent"
            class="action-required"
            routerLink="/waste-profiles/change/{{ wasteProfile.id }}"
            matTooltip="Change"
          >
            <mat-icon svgIcon="recurring"></mat-icon>
            Change
          </a>
        </div>
      </ng-container>

      <ng-container *digitalPlatformPermission="'recall:waste_profile'">
        <div class="card-button" *ngIf="showRecallSignature">
          <a
            mat-button
            color="accent"
            class="action-required"
            (click)="openDialog(recallSignatureDialog)"
          >
            <mat-icon svgIcon="recurring"></mat-icon>
            Recall Signature
          </a>
        </div>
      </ng-container>

      <ng-container *digitalPlatformPermission="'sign:waste_profile'">
        <div class="card-button" *ngIf="showSignProfile">
          <a
            mat-button
            color="accent"
            class="action-required"
            *ngIf="!editChange && !editRecertification"
            [routerLink]="
              '/waste-profiles/edit/' + wasteProfile.id + '/signature'
            "
            matTooltip="Sign Profile"
          >
            <mat-icon>history_edu</mat-icon>
            Sign Profile
          </a>
          <a
            mat-button
            color="accent"
            class="action-required"
            *ngIf="editChange"
            [routerLink]="
              '/waste-profiles/change/' + wasteProfile.id + '/review'
            "
            [queryParams]="{ continue: true }"
            matTooltip="Sign Profile"
          >
            <mat-icon>history_edu</mat-icon>
            Sign Profile
          </a>
          <a
            mat-button
            color="accent"
            class="action-required"
            *ngIf="editRecertification"
            [routerLink]="'/waste-profiles/recertify/' + wasteProfile.id"
            [queryParams]="{ continue: true, sign: true }"
            matTooltip="Sign Profile"
          >
            <mat-icon>history_edu</mat-icon>
            Sign Profile
          </a>
        </div>
      </ng-container>

      <ng-container *digitalPlatformPermission="'duplicate:waste_profile'">
        <div class="card-button duplicate-btn-wrapper" *ngIf="showDuplicate">
          <a
            mat-button
            color="accent"
            class="action-required"
            (click)="duplicate()"
            matTooltip="{{ duplicateTooltipText() }}"
          >
            <mat-icon svgIcon="duplicate"></mat-icon>
            {{ isFullyExpired() ? '' : 'Duplicate' }}
          </a>
          <mat-icon-button
            *ngIf="!isFullyExpired()"
            mat-icon-button
            class="btn-hint"
            matTooltip='"Duplicate" creates a new copy of your profile. Contact your rep or coordinator to modify an existing profile.'
          >
            <mat-icon class="help-icon">help</mat-icon>
          </mat-icon-button>
        </div>
      </ng-container>

      <ng-container *digitalPlatformPermission="'view:waste_profile'">
        <div class="card-button" *ngIf="showView">
          <a
            mat-button
            color="accent"
            class="action-required"
            routerLink="/special-waste-view/{{ this.wasteProfile.id }}"
            matTooltip="View Profile"
          >
            <mat-icon svgIcon="folder"></mat-icon>
            {{ isFullyExpired() ? '' : 'View Profile' }}
          </a>
        </div>
      </ng-container>
    </div>
  </mat-card-content>
</mat-card>

<ng-template #profileUnavailableDialog>
  <div class="service-dialog">
    <h2>Document Unavailable</h2>
    <button
      mat-icon-button
      cdkFocusInitial
      class="close"
      aria-label="Close dialog"
      color="accent"
      [disableRipple]="true"
      [mat-dialog-close]=""
    >
      <mat-icon>close</mat-icon>
    </button>
    <p>
      We're sorry, but this document is unavailable in this application. Please
      contact your Sales Rep for the PDF of this Waste Profile
    </p>
  </div>
</ng-template>
<ng-template #deleteDialog>
  <div class="service-dialog">
    <h2>Are you sure you want to permanently delete this waste profile?</h2>
    <button
      mat-icon-button
      cdkFocusInitial
      class="close"
      aria-label="Close dialog"
      color="accent"
      [disableRipple]="true"
      [mat-dialog-close]=""
    >
      <mat-icon>close</mat-icon>
    </button>
    <div class="remove-modal-button-wrapper">
      <button mat-stroked-button [mat-dialog-close]="">Cancel</button>
      <button
        mat-flat-button
        color="accent"
        class="remove-button"
        (click)="deleteWasteProfile()"
      >
        Delete
      </button>
    </div>
  </div>
</ng-template>

<ng-template #recallSignatureDialog>
  <div class="service-dialog">
    <h2>Are you sure you want to recall this signature request?</h2>
    <button
      mat-icon-button
      cdkFocusInitial
      class="close"
      aria-label="Close dialog"
      color="accent"
      [disableRipple]="true"
      [mat-dialog-close]=""
    >
      <mat-icon>close</mat-icon>
    </button>
    <div class="remove-modal-button-wrapper">
      <button mat-stroked-button [mat-dialog-close]="">Cancel</button>
      <button
        mat-flat-button
        color="accent"
        class="remove-button"
        (click)="recallSignature()"
      >
        Recall
      </button>
    </div>
  </div>
</ng-template>
